import { API, getToken } from "@/lib/api";
import { toast } from "sonner";

// PDF authentifiziert laden (Pfad relativ zu /api)
export async function fetchPdfBlob(path) {
  const r = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${getToken()}` } });
  if (!r.ok) {
    let msg = `Download fehlgeschlagen (${r.status})`;
    try { msg = (await r.json()).detail || msg; } catch { /* kein JSON */ }
    throw new Error(msg);
  }
  const skipped = decodeURIComponent(r.headers.get("X-Skipped-Attachments") || "");
  return { blob: await r.blob(), skipped };
}

// Browser-Druckdialog für ein PDF-Blob (iframe, Fallback neues Fenster)
export function printPdfBlob(blob) {
  const url = URL.createObjectURL(blob);
  const iframe = document.createElement("iframe");
  Object.assign(iframe.style, { position: "fixed", right: "0", bottom: "0", width: "0", height: "0", border: "0" });
  iframe.src = url;
  document.body.appendChild(iframe);
  const fallback = () => {
    const w = window.open(url, "_blank");
    if (w) setTimeout(() => { try { w.print(); } catch { /* ignore */ } }, 800);
    else toast.warning("Druckdialog konnte nicht geöffnet werden (Pop-up-Blocker prüfen).");
  };
  iframe.onload = () => setTimeout(() => {
    try { iframe.contentWindow.focus(); iframe.contentWindow.print(); } catch { fallback(); }
  }, 500);
  setTimeout(() => { URL.revokeObjectURL(url); iframe.remove(); }, 60_000);
}

// Druckauswahl eines Schreibens: part = letter | attachments | all
export async function printDocumentPart(documentId, part) {
  const { blob, skipped } = await fetchPdfBlob(`/messages/documents/${documentId}/print?part=${part}`);
  if (skipped) toast.warning(`Nicht druckbar (bitte separat öffnen): ${skipped}`);
  printPdfBlob(blob);
}
